export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Bold.aca09cd4.woff2";